<template>
  <div class="BaseHistory">
    <v-data-table
        dense
        :headers="getColumns"
        :items="itemList"
        class="elevation-1"
        :options.sync="options"
        :loading="loading"
        fixed-header
        hide-default-footer
        :height="windowHeight"
        :search="searchTerm"
    >
      <template v-slot:top>
        <v-toolbar dense class="mt-2 pt-1 mb-2" elevation="1" color="gridtoolbar">
          <v-text-field
              dark
              v-model="searchTerm"
              label="Search"
              class="mx-4"
              clearable
              @input="onUpdateSearchTerm"
          ></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:item.old_value="{ item }">
        <span v-bind:class="{ changed_value: item.changed}">
          {{ item.old_value }}
        </span>
      </template>
    </v-data-table>
    <v-toolbar flat dense elevation="2" height="60">
      <v-btn
        :disabled="activeHistoryId === null"
        @click="onRestore"
      >
        Restore
      </v-btn>
    </v-toolbar>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import {mapFields} from "vuex-map-fields";
import {debounce} from "debounce";

export default {
  name: 'BaseHistoryRestore',
  props: ['storeDocItemId', 'activeHistoryId', 'windowHeight'],

  components: {},

  computed: {
    ...mapGetters('BaseHistoryRestore', ['getColumns']),
    ...mapFields('BaseHistoryRestore', ['wsUrl', 'options', 'totalRecords', 'options.page', 'onlyFailedView', 'briefView', 'itemList',
      'loading', 'deleteLoading', 'updateLoading', 'restoring', 'selectedItemList', 'searchTermFile', 'searchTerm', 'isAlive']),
  },

  methods: {
    ...mapActions('BaseHistoryRestore', ['openWebSocket', 'fetchItemList', 'fetchItem', 'fetchDeleteSelectedItem',
      'fetchSyncNotionSelectedItems', 'fetchRestoreSelectedItems', 'fetchActionSelectedItem']),
    ...mapMutations('BaseHistoryRestore', ['updateFilters']),

    onRestore() {
      this.selectedItemList = [{id: this.activeHistoryId}]
      this.fetchActionSelectedItem('restore')
      this.fetchItemList()
    },

    updateOptions() {
      // console.log('updateOptions')
      this.fetchItemList()
    },
    onUpdateSearchTerm: debounce(function () {
      // console.log('onUpdateSearchTerm')
      this.options.page = 1
      this.fetchItemList()
    }, 800),
  },
  created() {
    // this.wsUrl = this.wsRestore
    console.log('this.wsUrl', this.wsUrl)
  },
  mounted() {
    this.updateFilters({store_doc_id: this.storeDocItemId, history_id: this.activeHistoryId})
    this.fetchItemList({store_doc_id: this.storeDocItemId, history_id: this.activeHistoryId});
  },
  watch: {
    activeHistoryId: {
      immediate: true,
      handler: function (newVal, oldVal) {
        // this.wsUrl = this.wsRestore
        this.updateFilters({store_doc_id: this.storeDocItemId, history_id: this.activeHistoryId})
        this.fetchItemList({store_doc_id: this.storeDocItemId, history_id: this.activeHistoryId});
      }
    }
  },
}
</script>

<style scoped lang="scss">
.changed_value {
  color: darkred;
}
</style>
